"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SCHEMA = 'iglu:com.angi.entities/brand_attributes/jsonschema/1-0-0';
const allowedBrands = [
    'ANGI',
    'HOME_ADVISOR',
    'MYHAMMER_DE',
    'MYHAMMER_AT',
    'WERKSPOT_NL',
    'WERKSPOT_COM',
    'TRAVAUX_COM',
    'MYBUILDER_COM',
    'HOMESTARS_COM',
    'INSTAPRO_IT',
];
const potentialHABrandNames = ['HOMEADVISOR', 'HOME ADVISOR', 'HA'];
/**
 * Generates the brand_attributes context
 *
 * @param brandName - brand name
 */
const brandAttributesContext = (brandName) => {
    let capitalizedBrandName = brandName.toUpperCase();
    if (potentialHABrandNames.includes(capitalizedBrandName)) {
        capitalizedBrandName = 'HOME_ADVISOR';
    }
    if (!allowedBrands.includes(capitalizedBrandName)) {
        console.warn(`Invalid brand name "${brandName}". Please use one of the following: ${allowedBrands.join(', ')}`);
        return;
    }
    return {
        schema: SCHEMA,
        data: { name: capitalizedBrandName },
    };
};
exports.default = brandAttributesContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJhbmRBdHRyaWJ1dGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2RhdGFTdHJ1Y3R1cmVzL2VudGl0aWVzL2JyYW5kQXR0cmlidXRlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sTUFBTSxHQUFHLDBEQUEwRCxDQUFDO0FBQzFFLE1BQU0sYUFBYSxHQUFHO0lBQ2xCLE1BQU07SUFDTixjQUFjO0lBQ2QsYUFBYTtJQUNiLGFBQWE7SUFDYixhQUFhO0lBQ2IsY0FBYztJQUNkLGFBQWE7SUFDYixlQUFlO0lBQ2YsZUFBZTtJQUNmLGFBQWE7Q0FDaEIsQ0FBQztBQUNGLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxhQUFhLEVBQUUsY0FBYyxFQUFFLElBQUksQ0FBQyxDQUFDO0FBRXBFOzs7O0dBSUc7QUFDSCxNQUFNLHNCQUFzQixHQUFHLENBQUMsU0FBaUIsRUFBa0MsRUFBRTtJQUNqRixJQUFJLG9CQUFvQixHQUFHLFNBQVMsQ0FBQyxXQUFXLEVBQUUsQ0FBQztJQUVuRCxJQUFJLHFCQUFxQixDQUFDLFFBQVEsQ0FBQyxvQkFBb0IsQ0FBQyxFQUFFO1FBQ3RELG9CQUFvQixHQUFHLGNBQWMsQ0FBQztLQUN6QztJQUVELElBQUksQ0FBQyxhQUFhLENBQUMsUUFBUSxDQUFDLG9CQUFvQixDQUFDLEVBQUU7UUFDL0MsT0FBTyxDQUFDLElBQUksQ0FDUix1QkFBdUIsU0FBUyx1Q0FBdUMsYUFBYSxDQUFDLElBQUksQ0FDckYsSUFBSSxDQUNQLEVBQUUsQ0FDTixDQUFDO1FBQ0YsT0FBTztLQUNWO0lBRUQsT0FBTztRQUNILE1BQU0sRUFBRSxNQUFNO1FBQ2QsSUFBSSxFQUFFLEVBQUUsSUFBSSxFQUFFLG9CQUFvQixFQUFFO0tBQ3ZDLENBQUM7QUFDTixDQUFDLENBQUM7QUFFRixrQkFBZSxzQkFBc0IsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/dataStructures/entities/brandAttributes.ts